import qrCode from "../../assets/images/hangs-sushi-qr.png"
export function QRCode() {
    return (
        <div className="w-1/2 md:w-1/3 lg:w-1/4 mx-auto my-20">
            <h1 className="text-center">Scan å bestille Online</h1>
            <img className="my-12" src={qrCode} alt="qr order Tista sushi in halden Norway asian restaurant japanese cuisine" />
        </div>
    )
}